import * as XLSX from "xlsx-js-style";

const _write = XLSX.write.bind(XLSX);
const _writeFile = XLSX.writeFile.bind(XLSX);

XLSX.write = (wb, opts) => _write(wb, { ...opts, cellStyles: true });
XLSX.writeFile = (wb, filename, opts) =>
  _writeFile(wb, filename, { ...(opts || {}), cellStyles: true });

export function boldRows(ws, startRow0, endRow0) {
  if (!ws || !ws["!ref"]) return;
  const range = XLSX.utils.decode_range(ws["!ref"]);
  const end = Math.min(endRow0, range.e.r);
  for (let r = startRow0; r <= end; r++) {
    for (let c = range.s.c; c <= range.e.c; c++) {
      const addr = XLSX.utils.encode_cell({ r, c });
      const cell = ws[addr];
      if (!cell) continue;
      const prev = cell.s || {};
      cell.s = {
        ...prev,
        font: { ...(prev.font || {}), bold: true },
      };
    }
  }
}

/**
 * Bold thead row(s) from an HTML table that start at row `firstTheadRow0` in the sheet.
 */
export function boldDomTheadRows(ws, tableEl, firstTheadRow0 = 0) {
  if (!ws || !ws["!ref"]) return;
  const thead = tableEl?.querySelector?.("thead");
  const trCount = thead ? thead.querySelectorAll("tr").length : 0;
  const n = trCount > 0 ? trCount : 1;
  boldRows(ws, firstTheadRow0, firstTheadRow0 + n - 1);
}

/** Keep long IDs (SIM, MSN, etc.) as text so Excel does not round to 15 digits. */
export function forceWorksheetTextColumns(ws, columnIndexes = [], startRow0 = 1) {
  if (!ws?.["!ref"] || !columnIndexes.length) return;
  const range = XLSX.utils.decode_range(ws["!ref"]);
  for (let r = Math.max(startRow0, range.s.r); r <= range.e.r; r++) {
    columnIndexes.forEach((c) => {
      if (c < range.s.c || c > range.e.c) return;
      const addr = XLSX.utils.encode_cell({ r, c });
      const cell = ws[addr];
      if (!cell) return;
      const raw = cell.v == null ? "" : String(cell.v).trim();
      ws[addr] = {
        t: "s",
        v: raw === "-" ? "" : raw,
        z: "@",
      };
    });
  }
}

export default XLSX;
